module.exports = __webpack_public_path__ + "media/images/lp/ashinaga-aai/home/home-aai-student-box-image-1-bd9d665a05e863ca524f4a716b2dca0d.jpg";